import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getUser = async (user) => {
  return userRequest.get(`${DOMAIN}/api/user`);
};

export const getUserOne = async (id) => {
  return userRequest.get(`${DOMAIN}/api/user/one?id_user=${id}`);
};

export const postUser = async (data) => {
  return userRequest.post(`${DOMAIN}/api/user`, data);
};

export const putUser = async (id, data) => {
  return userRequest.put(`${DOMAIN}/api/user?id=${id}`, data);
};

export const putUserOne = async (id, data) => {
  return userRequest.put(`${DOMAIN}/api/user/one?id=${id}`, data);
};

export const putIsActive = async (data) => {
  return userRequest.put(`${DOMAIN}/api/user/IsActive`, data);
};

export const putShowInpresence = async (data) => {
  return userRequest.put(`${DOMAIN}/api/user/ShowInpresence`, data);
};       

//Signature
export const getSignature = async (id) => {
  return userRequest.get(`${DOMAIN}/api/user/signature?userId=${id}`);
};

export const postSignature = async (data) => {
  return userRequest.post(`${DOMAIN}/api/user/signature`, data);
};

//SOCIETE
export const getSociete = async (id) => {
  return userRequest.get(`${DOMAIN}/api/user/societe`);
};

export const postSociete = async (data) => {
  return userRequest.post(`${DOMAIN}/api/user/societe`, data);
};

//Personnel
export const getPersonne = async (user) => {
  return userRequest.get(`${DOMAIN}/api/user/personnel`);
};

export const postPersonnel = async (data) => {
  return userRequest.post(`${DOMAIN}/api/user/personnel`, data);
};

//Visiteur pieton
export const getPieton = async (user) => {
  return userRequest.get(`${DOMAIN}/api/user/pieton`);
};

export const postPieton = async (data) => {
  return userRequest.post(`${DOMAIN}/api/user/pieton`, data);
};

//Visiteur pieton Retour
export const getPietonRetour = async (user) => {
  return userRequest.get(`${DOMAIN}/api/user/pieton_retour`);
};

export const putPietonRetour = async (id) => {
  return userRequest.put(`${DOMAIN}/api/user/pieton_retour?id_visiteur=${id}`);
};